import * as types from '../constants/ActionTypes';

export const logout = () => ({
  type: types.LOGOUT
});
